export const localStorageKeys = {
  USER_TOKEN: "USER_TOKEN",
  PAYMENT_STATUS: "PAYMENT_STATUS",
};
